import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { ShieldIcon } from "@src/appV2/redesign/EmergencyCredits/components/ShieldIcon";

interface CancelShiftFooterProps {
  variant: "preview-credit" | "cancel-shift";
  showWhyCantIUseCredit?: boolean;
  onKeepShift: () => void;
  onPressAndHoldToCancel: () => void;
  onPreviewCredit: () => void;
  onWhyCantIUseCredit?: () => void;
}

export function CancelShiftFooter(props: CancelShiftFooterProps): JSX.Element {
  const {
    variant,
    showWhyCantIUseCredit = false,
    onKeepShift,
    onPressAndHoldToCancel,
    onPreviewCredit,
    onWhyCantIUseCredit,
  } = props;

  const isPreviewCreditVariant = variant === "preview-credit";

  return (
    <DialogFooter orientation="vertical" sx={{ marginTop: "auto" }}>
      <Stack spacing={3} sx={{ width: "100%" }}>
        {showWhyCantIUseCredit && (
          <TextButton
            underline
            sx={(theme) => ({
              color: theme.palette.primary.main,
              textAlign: "center",
            })}
            onClick={onWhyCantIUseCredit}
          >
            Why can&apos;t I use my cancellation credit?
          </TextButton>
        )}
        {isPreviewCreditVariant ? (
          <Button fullWidth variant="contained" size="large" onClick={onPreviewCredit}>
            <Stack direction="row" spacing={4} alignItems="center">
              <ShieldIcon variant="filled" sx={{ fontSize: 16 }} />
              <Text color="inherit">Preview my cancellation credit</Text>
            </Stack>
          </Button>
        ) : (
          <Button
            fullWidth
            variant="outlined"
            size="large"
            sx={(theme) => ({
              color: theme.palette.error.main,
              borderColor: theme.palette.border?.primary,
            })}
            onClick={onPressAndHoldToCancel}
          >
            Press and hold to cancel
          </Button>
        )}
        <Button
          fullWidth
          variant="outlined"
          size="large"
          sx={(theme) => ({
            color: theme.palette.text.primary,
            borderColor: theme.palette.border?.primary,
          })}
          onClick={onKeepShift}
        >
          Keep my shift
        </Button>
      </Stack>
    </DialogFooter>
  );
}
